import { Component, Inject, OnInit, OnDestroy, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DateTimeFormatOptions } from 'luxon';
import { Merchant } from 'projects/common/src/lib/merchant';
import { OrderTypeEnum } from 'projects/common/src/lib/ordertype';
import { ISchedule, ScheduleType } from 'projects/common/src/lib/store-cart.model';
import { StoreCartService } from 'projects/services/src/lib/store-cart.service';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class DayObject {
  public date: number; // 1-28/30/31 for day of the month
  public month: number;
  public year: number;
  public day: number; // 0-6 for day of the week
  public disabled = false;
  public times: TimeSlot[] = [];
}

class TimeSlot {
  public time: string;
  public value: number;
}

export interface IScheduleDialogData {
  orderType: OrderTypeEnum;
  orderTypeDesc: string;
  schedule: ISchedule;
  merchant: Merchant;
  isCheckout: boolean;
}

const TIMEINTERVAL = 5 * 60 * 1000;

@Component({
  selector: 'app-schedule-dialog',
  templateUrl: './schedule-dialog.component.html',
  styleUrls: ['./schedule-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScheduleDialogComponent implements OnInit, OnDestroy, AfterViewInit {

  private timeFormatOptions = { hour: 'numeric', hour12: true, minute: '2-digit' } as DateTimeFormatOptions;
  private dateFormatOptions = { dateStyle: 'medium' } as DateTimeFormatOptions;
  private merchantInfo: Merchant;
  public isCheckout: boolean;

  public Schedule: ISchedule;
  public sType = '0';
  public dtype = 0;
  public datePicker: DayObject[];
  public selectedDate: DayObject;
  public selectedTime: TimeSlot;
  public availableTimeSlots: TimeSlot[];
  public noTimesAvailable = false;
  public closedToday = false;
  public deliverySuspended = false;
  public pickupSuspended = false;

  public days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  public monthNames = [];
  public deliveryTimeText = '';
  public orderTypes = [];

  public defaultOperationTime = [];
  public waittime = 0;

  modalElement: any;

  constructor(
    private dialogRef: MatDialogRef<ScheduleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IScheduleDialogData,
    private _snackbar: MatSnackBar,
    private _cartSvc: StoreCartService
  ) {

  }

  ngOnInit() {

    // do not place disableBodyScroll in constructor, it intereferes with loading the reactive forms
    this.modalElement = document.querySelector('#body-content');
    disableBodyScroll(this.modalElement);

    /*     this.merchantInfo = this.data.merchant;

        this.orderTypes = this.merchantInfo.orderOptions.filter(o => {
          if (o.enabled) {
            if (o.value === OrderTypeEnum.Delivery) {
              this.dtype = o.value;
              this.defaultOperationTime = this.merchantInfo.settings.deliveryHours;
              this.waittime = this.merchantInfo.settings.delWaittime ? this.merchantInfo.settings.delWaittime : 0;
            }
            return o;
          }
        });

        if (this.data.orderType) {
          this.dtype = this.data.orderType;
          if (this.dtype === OrderTypeEnum.Delivery) {
            this.defaultOperationTime = this.merchantInfo.settings.deliveryHours;
            this.waittime = this.merchantInfo.settings.delWaittime ? this.merchantInfo.settings.delWaittime : 0;
          } else {
            this.defaultOperationTime = this.merchantInfo.settings.pickupHours;
            this.waittime = this.merchantInfo.settings.pickupWaittime ? this.merchantInfo.settings.pickupWaittime : 0;
          }
        } else {
          if (this.dtype !== OrderTypeEnum.Delivery) {
            this.dtype = this.orderTypes[0].value;
            this.defaultOperationTime = this.merchantInfo.settings.pickupHours;
            this.waittime = this.merchantInfo.settings.pickupWaittime ? this.merchantInfo.settings.pickupWaittime : 0;
          }
        }

        this.Schedule = this.data.schedule;
        this.checkClosedToday();
        this._cartSvc.UpdateDeliveryType(this.dtype);

        this.SetupDatePicker();
        this.SetupTimePicker();
        this.SetupSelectedDate();
        this.SetDeliveryType(this.data.orderType); */
  }

  ngAfterViewInit() {
    this.merchantInfo = this.data.merchant;
    this.isCheckout = this.data.isCheckout;

    this.orderTypes = this.merchantInfo.orderOptions.filter(o => {
      if (o.enabled) {
        if (o.value === OrderTypeEnum.Delivery) {
          this.dtype = o.value;
          this.defaultOperationTime = this.merchantInfo.settings.deliveryHours;
          this.waittime = this.merchantInfo.settings.delWaittime ? this.merchantInfo.settings.delWaittime : 0;
          this.deliverySuspended = o.suspended;
        } else {
          this.pickupSuspended = o.suspended;
        }
        return o;
      }
    });

    if (this.data.orderType) {
      this.dtype = this.data.orderType;
      if (this.dtype === OrderTypeEnum.Delivery) {
        this.defaultOperationTime = this.merchantInfo.settings.deliveryHours;
        this.waittime = this.merchantInfo.settings.delWaittime ? this.merchantInfo.settings.delWaittime : 0;
      } else {
        this.defaultOperationTime = this.merchantInfo.settings.pickupHours;
        this.waittime = this.merchantInfo.settings.pickupWaittime ? this.merchantInfo.settings.pickupWaittime : 0;
      }
    } else {
      if (this.dtype !== OrderTypeEnum.Delivery) {
        this.dtype = this.orderTypes[0].value;
        this.defaultOperationTime = this.merchantInfo.settings.pickupHours;
        this.waittime = this.merchantInfo.settings.pickupWaittime ? this.merchantInfo.settings.pickupWaittime : 0;
      }
    }

    this.Schedule = this.data.schedule;
    this.checkClosedToday();
    // this._cartSvc.UpdateDeliveryType(this.dtype);

    this.SetupDatePicker();
    this.SetupTimePicker();
    this.SetupSelectedDate();
    this.SetDeliveryType(this.data.orderType);
  }

  ngOnDestroy() {
    enableBodyScroll(this.modalElement);
  }

  public Cancel() {
    enableBodyScroll(this.modalElement);
    // return original data
    this.dialogRef.close(null);
  }

  private checkClosedToday() {
    const d = new Date();

    const closeTime = (this.defaultOperationTime[d.getDay()].closeHour) ? this.defaultOperationTime[d.getDay()].closeHour.split(':') : [];
    let close: number;

    if ((this.dtype === OrderTypeEnum.Delivery && this.deliverySuspended) || (this.dtype === OrderTypeEnum.PickUp && this.pickupSuspended) ||
      this.defaultOperationTime[d.getDay()].available === false || !this.defaultOperationTime[d.getDay()].openHour || this.defaultOperationTime[d.getDay()].openHour.trim() === '' || closeTime.length <= 1) {
      this.sType = '1';
      this.closedToday = true;
      // this.noTimesAvailable = true;
    } else {
      if (closeTime.length > 1) {
        const t = new Date(d);
        if (closeTime[1].indexOf('PM') !== -1 && closeTime[0].trim() !== '12') {
          close = t.setHours(parseInt(closeTime[0].trim(), 10) + 12, parseInt(closeTime[1].trim(), 10), 0, 0); // this.merchantInfo.settings.closeTime - needs to be a 24 hour digit (0-23)
        } else {
          close = t.setHours(parseInt(closeTime[0].trim(), 10), parseInt(closeTime[1].trim(), 10), 0, 0); // this.merchantInfo.settings.closeTime - needs to be a 24 hour digit (0-23)
        }
      }

      if (d.getTime() + this.waittime * 60 * 1000 > close) {
        this.sType = '1';
        this.closedToday = true;
      } else {
        this.sType = `${this.data.schedule.text}`;
        this.closedToday = false;
      }
      // this.noTimesAvailable = false;
    }
  }

  public Confirm() {
    this.Schedule.text = this.sType === '0' ? ScheduleType.ASAP : ScheduleType.SCHEDULED;
    this._cartSvc.UpdateDeliveryType(this.dtype);

    const now = new Date().getDate();
    const selected = new Date(this.Schedule.value).getDate();
    if (now === selected) {
      if (this.Schedule.value === this.availableTimeSlots[0].value) {
        this.Schedule.asap = true;
      } else {
        this.Schedule.asap = false;
      }
    } else {
      this.Schedule.asap = false;
    }

    enableBodyScroll(this.modalElement);
    this.dialogRef.close(this.Schedule);
  }

  public SetDeliveryType(type) {
    this.dtype = type;
    this._cartSvc.UpdateDeliveryType(this.dtype);

    if (this.dtype === OrderTypeEnum.Delivery) {
      this.defaultOperationTime = this.merchantInfo.settings.deliveryHours;
      this.waittime = this.merchantInfo.settings.delWaittime ? this.merchantInfo.settings.delWaittime : 0;
    } else {
      this.defaultOperationTime = this.merchantInfo.settings.pickupHours;
      this.waittime = this.merchantInfo.settings.pickupWaittime ? this.merchantInfo.settings.pickupWaittime : 0;
    }

    this.checkClosedToday();
    this.SetupDatePicker();
    this.SetupTimePicker();

    this.SetupSelectedDate();
  }

  public SetScheduleType(type: string) {
    this.sType = type;
    if (this.sType === ScheduleType.SCHEDULED) {
      this.Schedule.value = 0;
    }

    this.SetupSelectedDate();
  }

  private SetupDatePicker() {
    this.datePicker = [];
    const NOW = new Date();
    // get today:
    const today = new Date();
    const dayofweek = today.getDay();

    try {
      // reset today to the beginning of the week:
      today.setDate(today.getDate() - dayofweek);
      for (let i = 0; i < 14; i++) {
        const month = today.toLocaleDateString('default', { month: 'long' });
        if (this.monthNames.indexOf(month) === -1) { this.monthNames.push(month); }
        const dayobj = new DayObject();
        dayobj.date = today.getDate();
        dayobj.day = today.getDay();
        dayobj.month = today.getMonth();
        dayobj.year = today.getFullYear();


        if (this.dtype === OrderTypeEnum.PickUp) {
          // disable each day that's less than NOW

          dayobj.disabled = today < NOW ||
            (!this.merchantInfo.settings.pickupHours[dayobj.day].openHour ||
              !this.merchantInfo.settings.pickupHours[dayobj.day].closeHour ||
              this.merchantInfo.settings.pickupHours[dayobj.day].available === false ||
              this.pickupSuspended);
        }

        if (this.dtype === OrderTypeEnum.Delivery) {
          // disable each day that's less than NOW
          dayobj.disabled = today < NOW ||
            (!this.merchantInfo.settings.deliveryHours[dayobj.day].openHour ||
              !this.merchantInfo.settings.deliveryHours[dayobj.day].closeHour ||
              this.merchantInfo.settings.deliveryHours[dayobj.day].available === false ||
              this.deliverySuspended);
        }

        if (today.getDate() === NOW.getDate() && (this.closedToday || !this.merchantInfo.settings.Active)) {
          dayobj.disabled = true;
        }
        dayobj.times = [];
        this.datePicker.push(dayobj);
        today.setDate(today.getDate() + 1);
      }
    } catch (error) {
      console.log(error);
    }

  }

  /**
   * Generates time slots for each available day in the date picker
   * Creates time slots from opening to closing time at 5-minute intervals
   */
  private SetupTimePicker() {
    try {
      this.datePicker.forEach(dp => {
        // Only generate time slots for enabled (available) days
        if (!dp.disabled) {
          const d = new Date(dp.year, dp.month, dp.date);

          // Get the operating hours for this specific day of the week
          const dayOfWeek = d.getDay();
          const openTime = this.defaultOperationTime[dayOfWeek].openHour.split(':');
          const closeTime = this.defaultOperationTime[dayOfWeek].closeHour.split(':');

          let open: number;
          let close: number;

          // Parse opening time - convert from 12-hour format to 24-hour timestamp
          if (openTime.length > 1) {
            const hour = parseInt(openTime[0].trim(), 10);
            const minute = parseInt(openTime[1].trim(), 10);
            
            // Handle AM/PM conversion to 24-hour format
            // PM times: add 12 hours (except for 12 PM which stays 12)
            // AM times: 12 AM becomes 0, all other AM times stay the same
            open = d.setHours(
              openTime[1].toLowerCase().includes('pm') && hour !== 12 ? hour + 12 :
                openTime[1].toLowerCase().includes('am') && hour === 12 ? 0 : hour,
              minute,
              0,
              0
            );
          } else {
            // Fallback: if no opening time specified, default to midnight
            open = d.setHours(0, 0, 0, 0);
          }

          // Parse closing time - convert from 12-hour format to 24-hour timestamp
          if (closeTime.length > 1) {
            const hour = parseInt(closeTime[0].trim(), 10);
            const minute = parseInt(closeTime[1].trim(), 10);
            
            // Same AM/PM conversion logic as opening time
            close = d.setHours(
              closeTime[1].toLowerCase().includes('pm') && hour !== 12 ? hour + 12 :
                closeTime[1].toLowerCase().includes('am') && hour === 12 ? 0 : hour,
              minute,
              0,
              0
            );
          } else {
            // Fallback: if no closing time specified, default to end of day
            close = d.setHours(23, 59, 0, 0);
          }

          // Create ASAP option for today's orders
          const dtAsap = new Date();
          const minutes = Math.ceil((new Date().getMinutes() + 1) / 5) * 5;
          const asap = dtAsap.setMinutes(minutes);

          const tsAsap = new TimeSlot();
          tsAsap.time = 'ASAP';
          tsAsap.value = 0;
          dp.times.push(tsAsap);

          // Generate time slots starting exactly at opening time
          // Each slot is 5 minutes apart (TIMEINTERVAL = 5 * 60 * 1000 milliseconds)
          let currentTime = open;
          
          while (currentTime < close) {
            const time = new Date(currentTime);
            const ts = new TimeSlot();
            // Format time for display (e.g., "10:00 AM", "3:30 PM")
            ts.time = time.toLocaleTimeString('default', this.timeFormatOptions);
            ts.value = currentTime;
            dp.times.push(ts);
            // Move to next 5-minute interval
            currentTime += TIMEINTERVAL;
          }
        }
      });

      // If a date is already selected, update the available time slots
      if (this.selectedDate) {
        this.SetupSelectedTime();
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Sets up the selected date based on schedule type and availability
   * Handles both ASAP (today) and scheduled (future) order types
   */
  private SetupSelectedDate() {
    if (this.sType === '0') {
      this.Schedule.value = 0;
    }

    if (this.Schedule.value === 0) {
      // No specific date selected - choose first available date
      const matchDate = this.datePicker.filter(d => !d.disabled);
      this.selectedDate = matchDate[0];
    } else {
      // Try to find the previously selected date
      const sd = new Date(this.Schedule.value);
      let matchDate = this.datePicker.filter(d => d.date === sd.getDate() && !d.disabled);
      if (matchDate.length === 0) {
        // Previously selected date no longer available - choose first available
        matchDate = this.datePicker.filter(d => !d.disabled);
      }
      this.selectedDate = matchDate[0];
    }
    this.SetupSelectedTime();
  }

  /**
   * Filters and sets up available time slots for the selected date
   * Handles wait time calculations, ASAP options, and time availability validation
   * Ensures orders can be completed within operating hours considering preparation time
   */
  private SetupSelectedTime() {
    let d = new Date();

    try {
      // If a future date is selected, use that date instead of current date
      if (this.selectedDate && (this.selectedDate.date !== d.getDate() || this.selectedDate.month !== d.getMonth() || this.selectedDate.year !== d.getFullYear())) {
        d = new Date(this.selectedDate.year, this.selectedDate.month, this.selectedDate.date);
      }

      let open: any;
      let close: any;
      let invalidDay = true;

      // Find a valid day with sufficient time for order preparation
      // This loop handles cases where the selected day might not have enough time
      // or when the store is closed/operating hours are invalid
      while (invalidDay) {
        const t = new Date(d);
        const openTime = this.defaultOperationTime[t.getDay()].openHour.split(':');
        const closeTime = this.defaultOperationTime[t.getDay()].closeHour.split(':');
        
        // Parse opening time with proper AM/PM handling (same logic as SetupTimePicker)
        if (openTime.length > 1) {
          const hour = parseInt(openTime[0].trim(), 10);
          const minute = parseInt(openTime[1].trim(), 10);
          open = t.setHours(
            openTime[1].toLowerCase().includes('pm') && hour !== 12 ? hour + 12 :
              openTime[1].toLowerCase().includes('am') && hour === 12 ? 0 : hour,
            minute,
            0,
            0
          );
        } else {
          open = t.setHours(0, 0, 0, 0);
        }

        // Parse closing time with AM/PM handling
        if (closeTime.length > 1) {
          const hour = parseInt(closeTime[0].trim(), 10);
          const minute = parseInt(closeTime[1].trim(), 10);
          close = t.setHours(
            closeTime[1].toLowerCase().includes('pm') && hour !== 12 ? hour + 12 :
              closeTime[1].toLowerCase().includes('am') && hour === 12 ? 0 : hour,
            minute,
            0,
            0
          );
        } else {
          close = t.setHours(23, 59, 0, 0);
        }

        // Check if this day is valid for ordering
        // Invalid if: no opening/closing times, or not enough time for preparation
        // waittime = preparation time (varies by merchant and order type)
        if (openTime.length === 1 || closeTime.length === 1 || 
            (d.getTime() + ((this.waittime) * 60 * 1000)) >= (close - ((this.waittime + 5) * 60 * 1000))) {
          this.closedToday = true;
          // Move to next day and try again
          d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        } else {
          invalidDay = false;
        }
      }

      // Store closing time for later use
      this.Schedule.close = close;

      // Calculate the first valid time slot based on date type
      let firstValidTime: number;
      
      if (this.selectedDate && (this.selectedDate.date !== new Date().getDate() || 
          this.selectedDate.month !== new Date().getMonth() || 
          this.selectedDate.year !== new Date().getFullYear())) {
        // Future date - start from opening time + wait time
        // Example: Store opens at opening time, first slot at opening time + pickup/delivery wait time
        firstValidTime = open + (this.waittime * 60 * 1000);
      } else {
        // Today - use either opening time or current time, whichever is later, then add wait time
        // Example: If current time is before opening → first slot at opening time + wait time
        // Example: If store is already open → first slot at current time + wait time
        firstValidTime = (open > d.getTime()) ? open : d.getTime();
        firstValidTime += (this.waittime * 60 * 1000);
      }

      // Filter available time slots based on preparation time constraints
      // 1. Must be after firstValidTime (ensures sufficient preparation time)
      // 2. Must be before closing time minus wait time (ensures order completion before closing)
      this.availableTimeSlots = [];
      this.availableTimeSlots = this.selectedDate.times.filter(t => 
        t.value >= firstValidTime && 
        t.value < close - (this.waittime * 60 * 1000)
      );

      // Handle ASAP option for today's orders only
      if (!this.closedToday && d.getDate() === this.selectedDate.date) {
        const asap = this.availableTimeSlots.filter(t => t.time.indexOf('ASAP') >= 0);
        if (asap.length > 1) {
          // Remove duplicate ASAP entries
          this.availableTimeSlots.splice(0, 1);
        } else if (asap.length < 1 && this.sType === '0') {
          // If no ASAP option but user wants ASAP, show approximate time
          this.availableTimeSlots[0].time = 'ASAP - Approximately ' + this.availableTimeSlots[0].time;
        }
      }

      // Check if any time slots are available after filtering
      this.noTimesAvailable = this.availableTimeSlots.length === 0;

      if (this.noTimesAvailable) {
        // No times available - switch to scheduled mode and try next available date
        this.sType = ScheduleType.SCHEDULED.toString();
        this.selectedDate.disabled = true;
        this.SetupSelectedDate();
      } else {
        // Times are available - select appropriate time slot
        if (this.Schedule.value === 0) {
          // No specific time selected - choose first available slot
          this.selectedTime = this.availableTimeSlots[0];
          this.Schedule.value = this.selectedTime.value;
        } else {
          // Try to find the previously selected time slot
          this.selectedTime = this.availableTimeSlots.filter(ats => ats.value === this.Schedule.value)[0];
          if (!this.selectedTime) {
            // Previously selected time no longer available - choose first available
            this.selectedTime = this.availableTimeSlots[0];
            this.Schedule.value = this.selectedTime.value;
          }
        }
      }

    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Handles date selection from the date picker
   * Updates available time slots for the selected date
   */
  public SelectDate(d: DayObject) {
    if (!d.disabled) {
      this.selectedDate = d;
      this.SetupSelectedTime();
    }
  }

  /**
   * Handles time slot selection from the dropdown
   * Updates the schedule value with the selected time
   */
  public SelectTime(e) {
    try {
      this.Schedule.value = this.selectedTime.value;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Generates the display text for the confirm button
   * Shows order type, date, and time information
   */
  AsapText(): string {
    if (this.selectedTime) {
      const d = new Date(this.selectedTime.value);
      d.setMonth(this.selectedDate.month);
      this.selectedTime.value = d.getTime();

      const ot = this.data.merchant.orderOptions.find((oo: any) => oo.desc === this.data.orderTypeDesc);
      const orderType = this.data.orderTypeDesc || 'Delivery';

      if (this.selectedTime.time === 'ASAP') {
        return `${orderType}, ${this.selectedTime.time}`;
      } else {
        return `${orderType}, ${d.toLocaleDateString('default', this.dateFormatOptions)} at ${d.toLocaleTimeString('default', this.timeFormatOptions)}`;
      }

    }
    return '';
  }

}
